// eslint-disable-next-line import/prefer-default-export
export const selectCurrency = ({ currency: { currency } }) => currency;
